import { render, staticRenderFns } from "./input-archivo.vue?vue&type=template&id=5ef2bd68&scoped=true&"
import script from "./input-archivo.vue?vue&type=script&lang=ts&"
export * from "./input-archivo.vue?vue&type=script&lang=ts&"
import style0 from "./input-archivo.vue?vue&type=style&index=0&id=5ef2bd68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef2bd68",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFileInput } from 'vuetify/lib/components/VFileInput';
installComponents(component, {VFileInput})
